import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import type { B2BTradersDatasetParams } from "./types";

dayjs.extend(customParseFormat);

export const DISPLAY_DATE_FORMAT = "DD.MM.YYYY";
export const DISPLAY_DATE_FORMATS = ["DD.MM.YYYY", "DD-MM-YYYY", "D.M.YYYY", "D-M-YYYY"] as const;
export const API_DATE_FORMAT = "YYYY-MM-DD";

/** Запетая/наклонена черта/numpad разделители → точка (DD.MM.YYYY). */
export function normalizeDisplayDateSeparators(value: string): string {
    return value
        .trim()
        .replace(/[,/]/g, ".")
        .replace(/[\u00B7\u2024\uFF0E\u2022\uFE52\uFE61]/g, ".");
}

/** Локална календарна дата (без UTC отместване от toISOString). */
export function formatLocalDateInput(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export function isoDateToDisplay(value: string) {
    const parsed = dayjs(value, API_DATE_FORMAT, true);

    return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : "";
}

export function displayDateToIso(value: string): string | null {
    const normalized = normalizeDisplayDateSeparators(value);

    if (!normalized) {
        return null;
    }

    const parsed = dayjs(normalized, [...DISPLAY_DATE_FORMATS], true);

    return parsed.isValid() ? parsed.format(API_DATE_FORMAT) : null;
}

/** Първи ден на текущия календарен месец (локално време). */
export function defaultPeriodDateFrom() {
    const date = new Date();

    date.setDate(1);

    return formatLocalDateInput(date);
}

export function defaultPeriodDateTo() {
    return formatLocalDateInput(new Date());
}

function defaultTradersDateFrom() {
    return defaultPeriodDateFrom();
}

function defaultTradersDateTo() {
    return defaultPeriodDateTo();
}

export function withDefaultTradersDates(params: B2BTradersDatasetParams = {}): B2BTradersDatasetParams {
    return {
        ...params,
        dateFrom: params.dateFrom?.trim() || defaultTradersDateFrom(),
        dateTo: params.dateTo?.trim() || defaultTradersDateTo(),
    };
}
